import { useAuth } from '@/contexts/AuthContext'
import { getTimeOfDayGreeting } from '@/lib/greeting'

export function WelcomeHeader() {
  const { user } = useAuth()
  const displayName = user?.given_name || user?.name || user?.email || 'there'
  const greeting = getTimeOfDayGreeting()

  return (
    <header className="space-y-1">
      <p className="text-xs font-semibold uppercase tracking-widest text-on-canvas-muted">
        Dashboard
      </p>
      <h1 className="text-3xl font-semibold tracking-tight text-on-canvas">
        {greeting}, {displayName}
      </h1>
    </header>
  )
}
